import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore';

const TierProtectedRoute = ({ requiredTier, children }) => {
  const { currentUser, isLoading } = useAuthStore();

  // 1. Si está cargando la sesión, no hacemos nada aún
  if (isLoading) return null;

  // 2. Si no hay usuario, redirigir al inicio
  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  // 3. Lógica de permisos (Admin o Tier específico)
  const adminRoles = ['admin', 'admin_root', 'moderator', 'technician', 'editor'];
  const hasAdminPower = adminRoles.includes(currentUser.role) ||
    (Array.isArray(currentUser.roles) && currentUser.roles.some(r => adminRoles.includes(r)));

  const hasRequiredTier = currentUser.tier &&
    String(currentUser.tier).toLowerCase() === String(requiredTier).toLowerCase();

  // 4. Si tiene permiso, renderiza los 'children' o el 'Outlet'
  if (hasAdminPower || hasRequiredTier) {
    return children ? children : <Outlet />;
  }

  // 5. Si no tiene permiso, fuera
  return <Navigate to="/" replace />;
};

export default TierProtectedRoute;
